export const formatCurrency = (value: string = "0", currency: string = "USD"): string => {
	switch (currency.toUpperCase()) {
		case "USD":
			return `$${value}`;
		case "RUB":
			return `${value} ₽`;
		default:
			return `${currency} ${value}`;
	}
};
